import React from 'react'
import { social_media_data } from './socialMediaData'
export default function SocialMedia()
{
    return (
        <div class="social">
            <ul>
                {social_media_data.map((item) => (
                    <li><a href={item.url} target="_blank"><i className={item.class}></i></a></li>
                ))}
            </ul>
        </div>
    )
}